import { render, staticRenderFns } from "./config-rule-hang.vue?vue&type=template&id=1604a4e0&"
import script from "./config-rule-hang.vue?vue&type=script&lang=js&"
export * from "./config-rule-hang.vue?vue&type=script&lang=js&"
import style0 from "./config-rule-hang.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports